import React, { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import { AuthContext } from "../../../Context/AuthContext";
import Preloader from "../../../shared/PreLoaders";
import TableComponent from "../../../utils/TableComponent";
import { Authorization } from "../../../Context/Authorization";

const ManageReceipt = () => {
  const [receipt, setReceipt] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const { permissions } = useContext(AuthContext);
  const Api = process.env.REACT_APP_API;

  useEffect(() => {
    const fetchReceipt = async () => {
      try {
        const Config = Authorization();
        const response = await fetch(`${Api}/api/transactions`, Config);
        const result = await response.json();
        const data = result.data;

        if (Array.isArray(data)) {
          const filteredReceipt = data.filter(
            (receipt) => receipt.type === "R"
          );
          setReceipt(filteredReceipt);
        }
      } catch (error) {
        console.error("Error fetching receipts", error);
      } finally {
        setLoading(false); // Set loading to false once data is fetched
      }
    };

    fetchReceipt();
  }, []);

  const handleDeleteReceipt = async (id) => {
    const confirmDelete = window.confirm(
      "Are you sure you want to delete this Receipt Details?"
    );
    if (!confirmDelete) {
      return;
    }
    try {
      await axios.delete(`${Api}/api/transactions/${id}`);
      setReceipt(receipt.filter((state) => state._id !== id));
      toast.success("Deleted Successfully");
    } catch (err) {
      console.error("Error deleting receipt", err);
      toast.error("Failed to delete receipt");
    }
  };

  const handleEdit = (id) => {
    navigate(`/manage/receipt/edit/${id}`);
  };

  const handleAddReceipt = () => {
    navigate("add/receipt");
  };

  const columns = [
    {
      headerName: "SI.No",
      field: "index",
      valueGetter: (params) => params.node.rowIndex + 1,
    },
    {
      headerName: "VFC Name",
      field: "vfcId.vfcName",
    },
    {
      headerName: "Account",
      field: "accountId.accountName",
    },
    {
      headerName: "Voucher Head",
      field: "voucherType",
    },
    {
      headerName: "Voucher Number",
      field: "voucherNumber",
    },
    {
      headerName: "Name",
      field: "partyDetails",
    },
    {
      headerName: "Amount",
      field: "amount",
    },
    {
      headerName: "Description",
      field: "description",
    },
    {
      headerName: "Cash/Bank",
      field: "cashOrBank",
    },
    {
      headerName: "Date",
      field: "date",
      valueFormatter: (params) => new Date(params.value).toLocaleDateString(),
    },
    {
      headerName: "View Document",
      field: "viewDocument",
      cellRenderer: (params) => {
        return params.data.uploadDocument ? (
          <a
            href={`${Api}${params.data.uploadDocument}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            View Document
          </a>
        ) : (
          "No document"
        );
      },
    },

    {
      headerName: "Action",
      field: "action",
      cellRenderer: (params) => {
        return (
          <div>
            {permissions.includes("EditReceipt") && (
              <i
                className="mdi mdi-pen"
                style={{
                  fontSize: "1.5rem",
                  cursor: "pointer",
                }}
                onClick={() => {
                  console.log("Navigating to edit:", params.data._id);
                  handleEdit(params.data._id);
                }}
              />
            )}
            {permissions.includes("DeleteReceipt") && (
              <i
                className="mdi mdi-delete"
                style={{
                  fontSize: "1.5rem",
                  cursor: "pointer",
                }}
                onClick={() => handleDeleteReceipt(params.data._id)}
              />
            )}
          </div>
        );
      },
    },
  ];

  return (
    <>
      <div className="page-header">
        <h3 className="page-title"> All Receipts </h3>
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <a href="!#" onClick={(event) => event.preventDefault()}>
                VFC
              </a>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              All Receipts
            </li>
          </ol>
        </nav>
      </div>

      <div>
        {loading ? (
          <Preloader loading={loading} />
        ) : receipt.length === 0 ? (
          <p>No receipts found</p>
        ) : (
          <div className="card">
            <div className="card-body">
              <div className="row icons-list">
                {permissions.includes("AddReceipt") && (
                  <div className="Add_btn">
                    <button
                      type="button"
                      className="btn btn-inverse-success"
                      onClick={handleAddReceipt}
                    >
                      Create New Receipt
                    </button>
                  </div>
                )}
                <div className="table-responsive">
                  <TableComponent data={receipt} columns={columns} />
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default ManageReceipt;
